/* Serial Seal — shared UI helpers: toast, modal, fallback pricing, local order
 * records. On the live store, checkout is Shopify's — these helpers back the
 * My Seals page and the offline fallbacks only.
 */
window.SS_UI = (function () {
  'use strict';

  // fallback pricing — the live product price always wins when it loads.
  // Owner ladder 2026-08-30: straight per-seal pricing, no bonus seals. A pack
  // is 12 Serial Seals(TM) at $6.00 ($0.50 each) and 60 is the minimum order,
  // so the smallest cart is 5 packs. Bulk rungs below are per-seal rates, in
  // ascending quantity order — read them, don't hardcode a rate elsewhere.
  var PRICING = {
    packSize: 12,
    pack: 6.00,        // 12 seals at the $0.50 entry rate
    minQty: 60,        // no quantity under 60 is purchasable
    tiers: [
      { qty: 60,   perSeal: 0.50 },
      { qty: 120,  perSeal: 0.45 },
      { qty: 600,  perSeal: 0.40 },
      { qty: 1200, perSeal: 0.36 },
      { qty: 2400, perSeal: 0.33 },
      { qty: 4200, perSeal: 0.30 }
      /* 2026-08-30: 60-seal starter entry at list; $0.30 is the floor and
         covers everything above 4,200 — past 10,008 is a volume quote,
         never a posted price. This array is the FALLBACK the builder paints from
         when /products/....js has not landed yet, so a stale rung here
         quotes a price checkout will not honour. */
    ]
  };

  function $(id) { return document.getElementById(id); }

  /* ---- toast ---- */
  var _tt = null;
  function toast(msg, bad) {
    var el = $('ss-toast');
    if (!el) {
      el = document.createElement('div'); el.id = 'ss-toast';
      el.setAttribute('role', 'status'); el.setAttribute('aria-live', 'polite');
      document.body.appendChild(el);
    }
    el.textContent = msg;
    el.className = bad ? 'show bad' : 'show';
    clearTimeout(_tt);
    _tt = setTimeout(function () { el.className = ''; }, 3200);
  }

  /* ---- modal ---- */
  var _lockY = 0;
  var _modalReturn = null;      /* what had focus before the dialog opened */
  function modal(innerHtml) {
    close();
    _modalReturn = document.activeElement;
    var ovl = document.createElement('div');
    ovl.className = 'ss-ovl open'; ovl.id = 'ss-ovl';
    ovl.innerHTML = '<div class="ss-modal" role="dialog" aria-modal="true" tabindex="-1">' +
      '<button class="x" aria-label="Close" onclick="SS_UI.close()">&times;</button>' +
      innerHtml + '</div>';
    ovl.addEventListener('click', function (e) { if (e.target === ovl) close(); });
    document.body.appendChild(ovl);
    /* stop the page behind the sheet from scrolling under the customer's
       thumb. overflow:hidden alone doesn't hold on iOS Safari — the page
       rubber-bands and the fixed bar wanders — so the body gets the
       position:fixed lock and we restore the scroll position on close. */
    _lockY = window.scrollY || 0;
    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.top = (-_lockY) + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.addEventListener('keydown', _esc);
    /* move focus INTO the dialog, or a keyboard user is still parked on the
       page behind it and Tab walks the obscured page (2.4.3 / 2.4.11) */
    var _mo = ovl.querySelector('.ss-modal');
    setTimeout(function () { try { _mo.focus(); } catch (_) {} }, 0);
  }
  function _esc(e) {
    if (e.key === 'Escape') { close(); return; }
    if (e.key !== 'Tab') return;
    var ovl = $('ss-ovl');
    if (!ovl) return;
    var mo = ovl.querySelector('.ss-modal');
    if (!mo) return;
    var all = mo.querySelectorAll('button,[href],input,select,textarea,[tabindex]:not([tabindex="-1"])');
    var f = [];
    for (var i = 0; i < all.length; i++) {
      if (all[i].offsetWidth || all[i].offsetHeight) f.push(all[i]);
    }
    if (!f.length) { e.preventDefault(); mo.focus(); return; }
    var first = f[0], last = f[f.length - 1], a = document.activeElement;
    if (e.shiftKey && (a === first || a === mo)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && a === last) { e.preventDefault(); first.focus(); }
    else if (!mo.contains(a)) { e.preventDefault(); first.focus(); }
  }
  function close() {
    var ovl = $('ss-ovl');
    if (!ovl) return;                       // close() also runs before opening
    ovl.remove();
    document.body.style.overflow = '';
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    window.scrollTo(0, _lockY);
    document.removeEventListener('keydown', _esc);
    /* hand focus back to whatever opened the dialog (2.4.3) */
    if (_modalReturn) {
      try { _modalReturn.focus({ preventScroll: true }); }
      catch (_) { try { _modalReturn.focus(); } catch (__) {} }
      _modalReturn = null;
    }
  }

  /* ---- beta order ---- */
  function orderCode(spec) {
    // deterministic-ish short code from the spec + a per-browser counter
    var s = JSON.stringify(spec), h = 5381;
    for (var i = 0; i < s.length; i++) h = ((h * 33) ^ s.charCodeAt(i)) >>> 0;
    var seq = 0;
    try {
      seq = (parseInt(localStorage.getItem('ss_seq') || '0', 10) + 1);
      localStorage.setItem('ss_seq', String(seq));
    } catch (_) {}
    return 'SSB-' + h.toString(36).toUpperCase().slice(0, 5) + '-' + String(100 + seq);
  }

  function orders() {
    try { return JSON.parse(localStorage.getItem('ss_orders') || '[]'); }
    catch (_) { return []; }
  }
  function saveOrders(all) {
    try { localStorage.setItem('ss_orders', JSON.stringify(all)); return true; }
    catch (_) { return false; }
  }

  var _lastOrderJson = '';   // full copyable record for the most recent order

  function betaOrder(spec) {
    spec = spec || {};
    var code = orderCode(spec);
    spec.order_code = code;
    spec.placed_at = new Date().toISOString();
    spec.status = 'submitted';        // browser-local lifecycle for My Seals
    /* v2 = the thumbs-carrying record shape. Records written from v2 on may or
       may not carry a `serials` array: ones saved before minting moved to the
       registry do, newer ones cannot — the numbers do not exist until the order
       is placed. Every reader treats it as optional. */
    spec.spec_version = 2;
    var all = orders();
    all.push(spec);
    var saved = saveOrders(all);
    if (!saved) {
      /* quota (thumbs add up) — drop the oldest orders' thumbs and retry */
      for (var d = 0; d < all.length - 1 && !saveOrders(all); d++) {
        delete all[d].artwork_thumb; delete all[d].logo_thumb;
      }
      saved = saveOrders(all);
      if (!saved) toast('Heads up — this order could not be saved to My Seals (browser storage is full). Email it now so it isn’t lost.', true);
    }

    /* the email/copy payload must NOT carry the preview thumbs — a base64
       blob turns the mailto URL into a several-hundred-KB link that every
       mail client rejects. Thumbs live only in localStorage for My Seals. */
    var emailSpec = {};
    for (var k in spec) {
      if (spec.hasOwnProperty(k) && k !== 'artwork_thumb' && k !== 'logo_thumb') emailSpec[k] = spec[k];
    }
    /* the Copy button always carries the FULL serial list; the mailto body
       caps it — Windows mail clients clip very long mailto URLs, and losing
       the tail of a 120-serial list silently would be worse than a pointer */
    _lastOrderJson = JSON.stringify(emailSpec, null, 2);
    var wireSpec = emailSpec;
    if (emailSpec.serials && emailSpec.serials.length > 24) {
      wireSpec = {};
      for (var k2 in emailSpec) if (emailSpec.hasOwnProperty(k2)) wireSpec[k2] = emailSpec[k2];
      wireSpec.serials = emailSpec.serials.slice(0, 12)
        .concat(['… +' + (emailSpec.serials.length - 12) + ' more — use "Copy details" for the full list']);
    }
    var json = JSON.stringify(wireSpec, null, 2);

    var lines = '';
    /* Records saved before minting moved to the registry carry their numbers;
       new ones carry none, because the numbers do not exist until the order is
       placed. Say that rather than dropping the row — a missing "Serials" line
       reads as "we forgot", and an empty one reads as "you got none". */
    var serialsLabel = spec.serials && spec.serials.length
      ? spec.serials.length + ' unique — ' + spec.serials.slice(0, 2).join(', ') + '…'
      : 'Assigned when the order is placed';
    /* `spec.qr` is the RENDERER channel, not a destination: it can hold a
       SENTINEL. 'none' means the seal prints without a code, and 'sku' means
       the code IS that seal's own serial (ss-seal.js substitutes it). Printed
       verbatim under a "QR link" heading, the POS mode read "QR link: sku" —
       a sentinel shown to a customer as an address. Say what each one is, and
       label the row for what it actually holds. */
    var qrRaw = String(spec.qr || '').trim();
    var qrLc = qrRaw.toLowerCase();
    var qrRow = qrLc === 'sku'
      ? ['QR code', 'Item code \u2014 each seal\u2019s code is its own serial']
      : qrLc === 'none'
      ? ['QR code', 'None \u2014 the seal prints without a code']
      : ['QR link', qrRaw];
    var show = [
      ['Order code', code],
      ['Design', spec.template_name || spec.template || ''],
      ['Brand text', spec.brand || ''],
      ['Serials', serialsLabel],
      ['Quantity', spec.qty ? (spec.qty + ' seals') : ''],
      qrRow,
      ['Beta price', spec.price != null ? ('$' + Number(spec.price).toFixed(2)) : '']
    ];
    for (var i = 0; i < show.length; i++) {
      if (!show[i][1]) continue;
      lines += '<div class="sumline"><span class="k">' + show[i][0] + '</span>' +
               '<span class="v">' + (window.SS ? SS.esc(show[i][1]) : show[i][1]) + '</span></div>';
    }


    modal(
      '<h3>Order saved <span aria-hidden="true" style="color:#3ecf8e">&#10003;</span></h3>' +
      '<p class="muted" style="font-size:14px">No payment is taken during beta. ' +
      'Email us the order and we’ll confirm your test run by reply. ' +
      'It’s also saved under <b>My Seals</b> on this device.</p>' +
      '<div style="margin:16px 0 4px">' + lines + '</div>' +
      '<div style="display:flex;gap:10px;flex-wrap:wrap;margin-top:14px">' +
      '<a class="btn" href="/pages/contact">Contact support</a>' +
      '<button class="btn2" onclick="SS_UI.copyOrder()">Copy details</button>' +
      '<a class="btn2" href="/pages/my-seals">My Seals</a>' +
      '</div>' +
      '<details style="margin-top:10px"><summary class="muted" ' +
      'style="cursor:pointer;font-size:13px">Full order data</summary>' +
      '<pre id="ss-ordjson">' + (window.SS ? SS.esc(json) : json) + '</pre></details>'
    );
  }

  function copyOrder() {
    var pre = $('ss-ordjson');
    if (!pre && !_lastOrderJson) return;
    var txt = _lastOrderJson || pre.textContent;
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(txt).then(function () { toast('Order details copied'); },
        function () { _fallbackCopy(txt); });
    } else _fallbackCopy(txt);
  }
  function _fallbackCopy(txt) {
    var ta = document.createElement('textarea');
    ta.value = txt; document.body.appendChild(ta); ta.select();
    try { document.execCommand('copy'); toast('Order details copied'); }
    catch (_) { toast('Copy failed — select the text manually', true); }
    ta.remove();
  }

  /* nav badge: every page's "My Seals" link shows how many orders live on
     this device — the one piece of cart-style feedback a static beta can give */
  function badgeNav() {
    var n = orders().length;
    document.querySelectorAll('a.nl[href="/pages/my-seals"]').forEach(function (a) {
      var b = a.querySelector('.nlb');
      if (!n) { if (b) b.remove(); return; }
      if (!b) {
        b = document.createElement('span');
        b.className = 'nlb';
        b.setAttribute('aria-label', n + ' saved orders');
        a.appendChild(b);
      }
      b.textContent = n;
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', badgeNav);
  else badgeNav();

  return { PRICING: PRICING, toast: toast, modal: modal, close: close,
           betaOrder: betaOrder, copyOrder: copyOrder,
           orders: orders, saveOrders: saveOrders, badgeNav: badgeNav };
})();
